import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const PageInput = ({ page, totalPages, onPageChange }) => {
    const [inputPage, setInputPage] = useState(page);

    const handleInputChange = (e) => {
        setInputPage(e.target.value);
    };

    const handleManualPageChange = (event) => {
        if (event.key === "Enter") {
            let newPage = parseInt(inputPage, 10);
            if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
                onPageChange(newPage);
            } else {
                setInputPage(page); // Restablece si el número ingresado es inválido
            }
        }
    };

    return (
        <TextField
            type="number"
            value={inputPage}
            onChange={handleInputChange}
            onKeyPress={handleManualPageChange}
            variant="outlined"
            size="small"
            style={{ width: "120px", marginLeft: "10px" }}
            inputProps={{ min: 1, max: totalPages }}
            color="primary"

            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon color="primary" />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PageInput;
